import platformStorage from './platformStorage';

export const LEGACY_REMEMBER_KEYS = ['x-remember-me', 'x-remember-email', 'x-remember-password'];

const purgeRememberedCredentials = async (): Promise<void> => {
  for (const key of LEGACY_REMEMBER_KEYS) {
    await platformStorage.remove(key);
    try {
      window?.localStorage?.removeItem(key);
    } catch (e) {
      continue;
    }
  }
};

export default purgeRememberedCredentials;
